<template>
  <div>
    <div v-if="loading" class="text-center">
      <small class="text-muted">Cargando...</small><br />
      <div class="lds-circle"><div></div></div>
    </div>
    <div v-else>
      <transition appear name="slide-fade">
        <div>
          <h4>Categorías</h4>
          <div class="row">
            <div class="col-6 text-center">
              <router-link to="/categoria/1" class="card card-body p-1">
                <img
                  src="assets/images/icons/new/Estetica_y_Belleza.png"
                  class="img-categoria mx-auto"
                  alt="Belleza"
                />
                <div class="text-center title-categoria">
                  Estética y belleza
                </div>
              </router-link>
            </div>
            <div class="col-6 text-center">
              <router-link to="/categoria/2" class="card card-body p-1 ms-1">
                <img
                  class="img-categoria mx-auto"
                  src="assets/images/icons/new/Gastrobar.png"
                  alt="Gastrobares"
                />
                <div class="text-center title-categoria">Gastrobares</div>
              </router-link>
            </div>
            <div class="col-6 text-center">
              <router-link to="/categoria/3" class="card card-body p-1 ms-1">
                <img
                  class="img-categoria mx-auto"
                  src="assets/images/icons/new/Rumba.png"
                  alt="Rumba"
                />
                <div class="text-center title-categoria">Rumba</div>
              </router-link>
            </div>
            <div class="col-6 text-center">
              <router-link to="/categoria/4" class="card card-body p-1 ms-1">
                <img
                  class="img-categoria mx-auto"
                  src="assets/images/icons/new/Turismo.png"
                  alt="Turismo"
                />
                <div class="text-center title-categoria">Turismo</div>
              </router-link>
            </div>
            <div class="col-6 text-center">
              <router-link to="/categoria/5" class="card card-body p-1 ms-1">
                <img
                  class="img-categoria mx-auto"
                  src="assets/images/icons/new/Cultura.png"
                  alt="Cultura"
                />
                <div class="text-center title-categoria">Entretenimiento y cultura</div>
              </router-link>
            </div>
            <div class="col-6 text-center">
              <router-link to="/categoria/6" class="card card-body p-1 ms-1">
                <img
                  class="img-categoria mx-auto"
                  src="assets/images/icons/new/Deporte.png"
                  alt="Deporte"
                />
                <div class="text-center title-categoria">
                  Deporte y acondicionamiento
                </div>
              </router-link>
            </div>

            <div class="col-6 text-center">
              <router-link to="/categoria/7" class="card card-body p-1 ms-1">
                <img
                  class="img-categoria mx-auto"
                  src="assets/images/icons/new/Espiritualidad_consciencia.png"
                  alt="Espiritualidad_y_Consciencia"
                />
                <div class="text-center title-categoria">
                  Espiritualidad y consciencia
                </div>
              </router-link>
            </div>

            <div class="col-6 text-center">
              <router-link to="/categoria/8" class="card card-body p-1 ms-1">
                <img
                  class="img-categoria mx-auto"
                  src="assets/images/icons/new/Educacion.png"
                  alt="Educacion"
                />
                <div class="text-center title-categoria">Educación</div>
              </router-link>
            </div>

            <div class="col-6 text-center">
              <router-link to="/categoria/9" class="card card-body p-1 ms-1">
                <img
                  class="img-categoria mx-auto"
                  src="assets/images/icons/new/Negocios_verdes.png"
                  alt="Servicios"
                />
                <div class="text-center title-categoria">Negocios verdes</div>
              </router-link>
            </div>

            <div class="col-6 text-center">
              <router-link to="/categoria/10" class="card card-body p-1 ms-1">
                <img
                  class="img-categoria mx-auto"
                  src="assets/images/icons/new/Servicios_especializados.png"
                  alt="Servicios"
                />
                <div class="text-center title-categoria">
                  Servicios especializados
                </div>
              </router-link>
            </div>

            <div class="col-6 text-center">
              <router-link to="/categoria/11" class="card card-body p-1 ms-1">
                <img
                  class="img-categoria mx-auto"
                  src="assets/images/icons/new/Hogar.png"
                  alt="Hogar"
                />
                <div class="text-center title-categoria">Hogar</div>
              </router-link>
            </div>

            <div class="col-6 text-center">
              <router-link to="/categoria/12" class="card card-body p-1 ms-1">
                <img
                  class="img-categoria mx-auto"
                  src="assets/images/icons/new/Moda_y_accesorios.png"
                  alt="Moda_y_accesorios"
                />
                <div class="text-center title-categoria">Moda y accesorios</div>
              </router-link>
            </div>

            <div class="col-6 text-center">
              <router-link to="/categoria/13" class="card card-body p-1 ms-1">
                <img
                  class="img-categoria mx-auto"
                  src="assets/images/icons/new/Automotriz.png"
                  alt="Automotriz"
                />
                <div class="text-center title-categoria">Automotríz</div>
              </router-link>
            </div>

            <div class="col-6 text-center">
              <router-link to="/categoria/14" class="card card-body p-1 ms-1">
                <img
                  src="assets/images/icons/new/Salud.png"
                  class="img-categoria mx-auto"
                  alt="Salud"
                />
                <div class="text-center title-categoria">Salud</div>
              </router-link>
            </div>

            <div class="col-6 text-center">
              <router-link to="/categoria/15" class="card card-body p-1 ms-1">
                <img
                  class="img-categoria mx-auto"
                  src="assets/images/icons/new/Mascotas.png"
                  alt="Mascotas"
                />
                <div class="text-center title-categoria">Mascotas</div>
              </router-link>
            </div>

            <div class="col-6 text-center">
              <router-link to="/categoria/16" class="card card-body p-1 ms-1">
                <img
                  class="img-categoria mx-auto"
                  src="assets/images/icons/new/Tecnologia_y_Electrodomesticos.png"
                  alt="Servicios"
                />
                <div class="text-center title-categoria">
                  Tecnología y electrodomésticos
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
//import axios from "axios";
export default {
  name: "Categorias",
  metaInfo: {
    title: "Categorias - Reddy App",
  },
  data() {
    return {
      loading: true,
    };
  },
  props: {},
  created: function () {},
  methods: {},
  mounted: function () {
    this.loading = false;
  },
};
</script>
